import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyDetails } from "../../data/component/models-interfaces/manage-company/company-interface";
@Injectable({
  providedIn: "root",
})
export class SpecialityService {
  constructor(private httpClient: HttpClient) { }

  getAllSpecialityList(page: any, limit: any, search?: any) {
    const apiUrl = `${environment.serverEndPoint}/speciality/list?page=${page}&limit=${limit}&search=${search}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getSpeciality(id: any) {
    const apiUrl = `${environment.serverEndPoint}/speciality/` + id;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  createSpeciality(data: any) {
    const apiUrl = `${environment.serverEndPoint}/speciality/create`;
    return this.httpClient.post<CompanyDetails>(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  updateSpeciality(id: any, data: any) {
    const apiUrl = `${environment.serverEndPoint}/speciality/update/` + id;
    return this.httpClient.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getSpecialityDropDown() {
    const apiUrl = `${environment.serverEndPoint}/speciality/dropdown/list`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  deleteSpeciality(id: any, data: boolean) {
    const sendData = { isDeleted: data };
    const apiUrl = `${environment.serverEndPoint}/speciality/status-update/` + id;
    return this.httpClient.put(apiUrl, sendData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

}
